import { RealEstateCategory, SegmentationType, TransactionType } from '../../../@types/types'

export interface ValidationErrors {
  identity?: string[]
  intent?: string[]
  propertyTypes?: string[]
}

export interface SegmentationFormData {
  selectedSegmentation: SegmentationType | null
  selectedTransaction: TransactionType | 'SHORT_TERM_ACCOMMODATION' | undefined
  selectedPropertyTypes: RealEstateCategory[]
  showBusinessCategories: boolean
  availableRealEstateTypes: Array<RealEstateCategory | 'BUSINESS'>
}

/**
 * Validates the segmentation form data
 * Returns an object with validation errors, empty object if valid
 */
export const validateSegmentationForm = (data: SegmentationFormData): ValidationErrors => {
  const errors: ValidationErrors = {}

  // Identity (segmentation type) is always required
  if (!data.selectedSegmentation) {
    errors.identity = ['segmentationRequired']
  }

  // Transaction/Intent is always required
  if (!data.selectedTransaction) {
    errors.intent = ['transactionRequired']
  }

  // Real estate type is required UNLESS transaction is SHORT_TERM_ACCOMMODATION
  // Show error even if transaction is not selected yet (to show all errors at once)
  if (
    (!data.selectedTransaction || data.selectedTransaction !== 'SHORT_TERM_ACCOMMODATION') &&
    data.selectedPropertyTypes.length === 0 &&
    !data.showBusinessCategories &&
    data.availableRealEstateTypes.length > 0
  ) {
    errors.propertyTypes = ['realEstateRequired']
  }

  // Business type is required when business categories are visible
  if (data.showBusinessCategories && data.selectedPropertyTypes.length === 0) {
    errors.propertyTypes = ['realEstateRequired']
  }

  return errors
}

/**
 * Checks if the segmentation form is valid (no errors)
 */
export const isSegmentationFormValid = (data: SegmentationFormData): boolean => {
  const errors = validateSegmentationForm(data)
  return Object.keys(errors).length === 0
}
